module.exports = __webpack_public_path__ + "images/pdf-876047bb.png";